import Axios from 'axios'
import JSONP from 'jsonp'

export default class API {
  static getLogisticsData ({ type = 'pp', bidType = '', skip = 0, limit = 10, status = '', supEnterpriseIds = 0, messageTitle = '', purOrgName = '', startPublishTime = null, endPublishTime = null, startTime = null, endTime = null }) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_BASE_URL}/yuncai/xqjsonp/supplierOffer/xqlist?type=${type}&bidType=${bidType}&supEnterpriseIds=${supEnterpriseIds}&status=${status}&pageSize=${limit}&pageIndex=${skip}`
      if (messageTitle) {
        url += `&messageTitle=${messageTitle}`
      }
      if (purOrgName) {
        url += `&purOrgName=${purOrgName}`
      }
      if (startPublishTime) {
        url += `&startPublishTime=${startPublishTime}`
      }
      if (endPublishTime) {
        url += `&endPublishTime=${endPublishTime}`
      }
      if (startTime) {
        url += `&startTime=${startTime}`
      }
      if (endTime) {
        url += `&endTime=${endTime}`
      }
      JSONP(url, null, (err, data) => {
        if (err) {
          console.log(err)
          reject(err)
        } else {
          resolve(data)
        }
      })
    })
  }

  static getEntNotice ({ tenantid = '', skip = 0, limit = 10 }) {
    return Axios.get(`${process.env.VUE_APP_BASE_URL}/gwmanage/pub/notice/entnotice?tenantid=${tenantid}&pageSize=${limit}&pageIndex=${skip}`)
    // return new Promise((resolve, reject) => {
    //   JSONP(`${process.env.VUE_APP_BASE_URL}/gwmanage/pub/notice/entnotice?tenantid=${tenantid}&pageSize=${limit}&pageIndex=${skip}`, null, (err, data) => {
    //     if (err) {
    //       reject(err)
    //     } else {
    //       resolve(data)
    //     }
    //   })
    // })
  }

  // 采购交易额(物料)
  static getTransactionList () {
    return Axios.post('/cpu-project-def/ycctrl/dateBoard/transactionList')
  }

  // 每月活跃的供应商数量
  static getEvalMonthSup () {
    return Axios.post('/cpu-project-def/ycctrl/dateBoard/evalMonthSup')
  }

  // 采购交易额增幅
  static getTradeOfIncrease () {
    return Axios.post('/cpu-project-def/ycctrl/dateBoard/tradeOfIncrease')
  }

  // 每月定标项目数量
  static getEvalMonthDecisions () {
    return Axios.post('/cpu-project-def/ycctrl/dateBoard/evalMonthDecisions')
  }
}
